import React from "react";
import { Form, Input, InputNumber, Radio, Select } from "antd";

const { TextArea } = Input;

function Infrastructure({ plainOptions, form, dataInfraStatus }) {
  const infrastructureIssues = Form.useWatch(
    "infrastructureIssues",
    form
  );

  return (
    <>
      <div className="custom-title !text-[#111928] rounded-[.5rem]">
        Infrastructure
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
        <Form.Item
          name="infrastructureIssues"
          label={"Do you have any infrastructure issues?"}
        >
          <Radio.Group options={plainOptions} />
        </Form.Item>

        <Form.Item name="operationalStatusId" label={"Operational Status"}>
          <Select
            allowClear
            placeholder="Select status"
            style={{
              width: "100%",
            }}
            options={
              dataInfraStatus?.length > 0 &&
              dataInfraStatus?.map((item) => ({
                value: item?.infsId,
                label: item?.infsName,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>


        {infrastructureIssues === "Yes" && (
          <Form.Item
            name="infrastructureIssuesDesc"
            label={"Describe the infrastructure issues"}
          >
            <TextArea
              rows={3}
              placeholder="Which structures are affected and how they impact production"
              className="text_area"
            />
          </Form.Item>
        )}

        <Form.Item
        extra={"The total cost to maintain the scheme "}
          name="omCost"
          label={"Operation and Maintenance Cost (KES)"}
        >
          <InputNumber
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Enter value"
            className="input flex"
          />
        </Form.Item>
        <Form.Item
          name="mechanizationLevel"
          label={"Level of Mechanization"}
        >
          <TextArea rows={3} className="text_area" />
        </Form.Item>
      </div>
    </>
  );
}

export default Infrastructure;
